import React, { useEffect, useState } from "react";

import UserRoleTags from "components/Tags/UserRoleTags";

import ActiveInactiveTags from "components/Tags/ActiveInactiveTags";

import formatDate from "utils/utils";
import { Button, Spinner, useToast } from "@chakra-ui/react";

import { GetLoginActivity } from "services/LoginActivityService";
import { GetForgetPasswordService } from "services/ForgetPasswordService";
import { GetResendInvitationEmail } from "services/AdminUserManagementServices";

import formateDateTime from "utils/formateDateTime";

export default function GeneralTab(props) {
  const userData = props.userData;

  const [lastLogin, setLastLogin] = useState("");

  const [loading, setLoading] = useState(false);

  const toast = useToast();

  useEffect(() => {
    const fetchLastLogin = async () => {
      try {
        const response = await GetLoginActivity({
          user_id: userData.user_id,
          page_size: 1,
          page_number: 0,
        });

        if (response.data.data.length === 0) {
          setLastLogin("No login activity");
        } else {
          setLastLogin(formateDateTime(response.data.data[0]?.created_on));
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchLastLogin();
  }, []);

  const handleResetPassword = () => {
    const callResetPassword = async () => {
      try {
        setLoading(true);
        const response = await GetForgetPasswordService({
          user_email: userData.user_email,
        });

        toast({
          title: "Password reset email sent successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });

        console.log(response, "response");
      } catch (error) {
        console.log(error);

        toast({
          title: "Error sending password reset email",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    };

    const callResendInvitation = async () => {
      try {
        setLoading(true);
        const response = await GetResendInvitationEmail({
          user_email: userData.user_email,
        });

        toast({
          title: "Invitation email sent successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });

        console.log(response, "response");
      } catch (error) {
        console.log(error);

        toast({
          title: "Error sending invitation email",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    };

    if (userData?.is_user_onboarded) {
      callResetPassword();
    } else {
      callResendInvitation();
    }
  };

  console.log(userData, "userData");

  return (
    <div>
      <table className="min-w-full  border primary-border-color bg-white   ">
        <tbody>
          <tr className="border-b     ">
            <td className="pl-4 py-4  h-5 w-[12rem]     ">
              <p className="table-heading  ">Full Name</p>
            </td>
            <td className=" table-text-light">
              {userData.first_name} {userData.last_name}{" "}
            </td>
          </tr>
          <tr className="border-b   ">
            <td className="pl-4 py-4 h-5 w-[12rem] ">
              <p className="table-heading">Email</p>
            </td>
            <td className=" table-text-light">
              <div className="w-full flex flex-row justify-between pr-6 gap-2">
                <div className="my-auto  ">
                  <a>{userData.user_email}</a>
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b   ">
            <td className="pl-4 py-4 w-[12rem]   ">
              <p className="table-heading">Role</p>
            </td>
            <td className=" table-text-light">
              {userData?.user_has_role.length > 0 ? (
                <UserRoleTags
                  role={userData.user_has_role[0]?.user_role_id?.user_role_name}
                />
              ) : (
                <UserRoleTags role={"None"} />
              )}
            </td>
          </tr>
          <tr className="border-b   ">
            <td className="pl-4 py-4 w-[12rem]   ">
              <p className="table-heading">Status</p>
            </td>
            <td className=" table-text-light">
              <ActiveInactiveTags is_active={userData?.user_is_active} />
            </td>
          </tr>
          <tr className="border-b    ">
            <td className="pl-4  py-4 w-[12rem]   ">
              <p className="table-heading">Creation Date</p>
            </td>
            <td className=" py-4 table-text-light">
              {formatDate(userData?.created_on)}
            </td>
          </tr>
          <tr className="border-b    ">
            <td className="pl-4  py-4 w-[12rem]   ">
              <p className="table-heading">Last Login</p>
            </td>
            <td className=" py-4 table-text-light">{lastLogin}</td>
          </tr>
          <tr className="border-b    ">
            <td className="pl-4  py-4 w-[12rem]   ">
              <p className="table-heading">Onboarding complete </p>
            </td>
            <td className=" py-4 table-text-light">
              {userData?.is_user_onboarded ? "Yes" : "No"}
            </td>
          </tr>
        </tbody>
      </table>
      <div className="w-full flex flex-row mt-8  gap-10 justify-end h-[3.13rem]  ">
        {userData?.user_is_active && (
          <>
            <div className="w-64">
              <Button onClick={handleResetPassword} isDisabled={loading}>
                {!loading ? (
                  userData?.is_user_onboarded ? (
                    "Reset User Password"
                  ) : (
                    "Resend Invitation email"
                  )
                ) : (
                  <Spinner size="sm" />
                )}
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
